//Import required libraries
import React, { useState, useEffect } from "react";

//Import custom components

//Import Styles
import "./Year.scss";

//Import Data
import { justifiedLayoutNaive } from "../../../utils/utils";

let scrollWidth = 4;
let initialTargetHeightLarge = 300;
let initialTargetHeightSmall = 200;

const Year = (props) => {
  let { setImageSelected, catSelected } = props;

  const [viewportWidth, setViewportWidth] = useState(
    Math.round(window.innerWidth - scrollWidth)
  );
  const [targetHeight, setTargetHeight] = useState(initialTargetHeightLarge);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(Math.round(document.documentElement.clientWidth - scrollWidth));
      setTargetHeight(
        window.innerWidth - scrollWidth < 600
          ? initialTargetHeightSmall
          : initialTargetHeightLarge
      );
      setCounter(counter + 1);
    };

    //Calling the handleResize within 100ms of loading to fix the mobile bug 
    setTimeout(() => {
      handleResize();
    }, 100);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let { year, pictures } = props;
  let layoutConfig = {
    viewportWidth,
    targetHeight,
    marginLeft: 5,
    marginRight: 0,
  };
  let rows = justifiedLayoutNaive(pictures, layoutConfig);

  return (
    <div className="year">
      {catSelected === "All" ? ( //Show year title only if category selected is All
        <div className="year-title">{year}</div>
      ) : (
        <div className="year-title-invisble"></div>
      )}
      <div className="pictures">
        {rows &&
          rows.map((row, index) => {
            let picRowStyle = {
              height: row[0].finalHeight,
            };
            return (
              <div key={index} className="picture-row" style={picRowStyle}>
                {row.map((obj, i) => {
                  let width = obj.finalWidth;
                  let height = obj.finalHeight;
                  let imgStyle = {
                    marginLeft: obj.marginLeft,
                    marginRight: obj.marginRight,
                  };
                  let device = obj.device === "mobile" ? "mobile" : "camera";
                  return (
                    <div key={i} className="click-container">
                      {/* <i className={`fa fa-${device}`} aria-hidden="true"></i> */}
                      <img
                        className="click"
                        key={i}
                        src={obj.urlCompressed}
                        width={width}
                        height={height}
                        style={imgStyle}
                        title="Click to expand"
                        onClick={() => {
                          setImageSelected(obj);
                        }}
                      ></img>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Year;
